import React, { useEffect, useState, useRef } from "react";
import { TextField, Button, Container, Grid, LinearProgress, CircularProgress } from "@mui/material";
import Message from "./Message";
//import OpenAI from "openai";
import { MessageDto } from "./MessageDto";
import SendIcon from "@mui/icons-material/Send";
//import fetch from 'node-fetch';
window.Buffer = window.Buffer || require("buffer").Buffer;
//import { AzureOpenAI } from 'openai';
const { AzureOpenAI } = require("openai");

const azureOpenAIKey = '9fb5af1332a648b1bba4198731e389bd';
const azureOpenAIEndpoint = 'https://pragyaaGPT4.openai.azure.com/';
const azureOpenAIVersion = "2024-05-01-preview";


//const API_KEY ="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"
const API_KEY ="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"
/*
const client = new OpenAI({
  apiKey: API_KEY,
  dangerouslyAllowBrowser: true,
});
*/
// Get Azure SDK client

const getClient = () => {
    const assistantsClient = new AzureOpenAI({
        endpoint: azureOpenAIEndpoint,
        apiVersion: azureOpenAIVersion,
        apiKey: azureOpenAIKey,
		dangerouslyAllowBrowser: true,
    });
    return assistantsClient;
};

//const assistantsClient = getClient();
//var client=assistantsClient;

const ExcelAnalysis = () => {
  const bottomRef = useRef(null);
  useEffect(() => {
    if (bottomRef && bottomRef.current) {
      bottomRef.current.scrollIntoView({behavior: 'smooth'});
    }
  });
	
	
  const [isWaiting, setIsWaiting] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [assistant, setAssistant] = useState(null);
  const [thread, setThread] = useState(null);
  const [openai, setOpenai] = useState(null);

  useEffect(() => {
    initChatBot();
  }, []);

  useEffect(() => {
	var msg=createNewMessage("Hi, I'm your personal assistant. How can I help you?", false);
	msg.setHasImage(false);
	setMessages([msg]);
/*	
    setMessages([
      {
        content: "Hi, I'm your personal assistant. How can I help you?",
        isUser: false,
      },
    ]);

	var msg=createNewMessage("", false);
	msg.setHasImage(true);
	var fileId="file-tpubVRwizUUy5czBLDqJ6sgE";
	var url1="https://api.openai.com/v1/files/"+fileId+"/content";
	getImageUrl(url1, msg);
*/
  }, [assistant]);

  const getImageUrl = (url,msg) => {

    try {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url);
	  xhr.setRequestHeader("Authorization", "Bearer "+API_KEY); 
      xhr.responseType = "blob";
      xhr.onerror = function() {
        console.log("Network error.")
      };
      xhr.onload = function() {
        if (xhr.status === 200) {
          
		  const reader = new FileReader();
		  reader.addEventListener("load", () => {
		    const uploaded_image = reader.result;
			console.log('imgContent: '+uploaded_image);
			msg.setImageContent(uploaded_image);
			setMessages([...messages, msg]);
		  });
		  reader.readAsDataURL(xhr.response);
        } else {
          console.log("Loading error:" + xhr.statusText)
        }
      };
      xhr.send();
    } catch (err) {
      console.log(err.message)
    }	
	
  }

  const initChatBot = async () => {
	/*
	const openai = new OpenAI({
	  apiKey: API_KEY,
	  dangerouslyAllowBrowser: true,
	});
	*/
	const openai = getClient();
    // Create an assistant
    //const assistant = 'asst_YAX7BqJ6LCLYsMyLsNDP26aQ';
    const assistant = 'asst_ZaPKG8VdBFBul7g4TmtP2XD3';

	/*
	const options = {
	    model: "pragyaagpt4", // replace with model deployment name
	    name: "Assistant677",
	    instructions: "",
	    tools: [{"type":"file_search"}],
	    
	    tool_resources: {"file_search":{"vector_store_ids":["vs_grT7QrdJ6naN8k80m3mMIZ1R"]}},
	    temperature: 0.2,
	    top_p: 1
	};

	const assistant = await openai.beta.assistants.create(options);
	*/
    // Create a thread
    const thread = await openai.beta.threads.create();

    setOpenai(openai);
    setAssistant(assistant);
    setThread(thread);
  };

  const createNewMessage = (content, isUser) => {
    const newMessage = new MessageDto(isUser, content);
	newMessage.setHasImage(false);
    return newMessage;
  };

  const handleSendMessage = async () => {
    messages.push(createNewMessage(input, true));
    setMessages([...messages]);
    setInput("");

    // Send a message to the thread
    await openai.beta.threads.messages.create(thread.id, {
      role: "user",
      content: input,
	  //file_ids:Object.values(fileIds),
    });

    // Run the assistant
    const run = await openai.beta.threads.runs.create(thread.id, {
      assistant_id: assistant,
    });

    // Create a response
    let response = await openai.beta.threads.runs.retrieve(thread.id, run.id);

    // Wait for the response to be ready
    while (response.status === "in_progress" || response.status === "queued") {
      console.log("waiting...");
      setIsWaiting(true);
      await new Promise((resolve) => setTimeout(resolve, 5000));
      response = await openai.beta.threads.runs.retrieve(thread.id, run.id);
    }

    setIsWaiting(false);

    // Get the messages for the thread
    const messageList = await openai.beta.threads.messages.list(thread.id);

	console.log('messageList: '+JSON.stringify(messageList));
	
    // Find the last message for the current run
    const lastMessage = messageList.data
      .filter((message) => message.run_id === run.id && message.role === "assistant")
      .pop();

    // Print the last message coming from the assistant
    if (lastMessage) {
		console.log('lastMessage : '+JSON.stringify(lastMessage));
		var newMessage;
		if (lastMessage.content[0].type === 'image_file'){
			var image_file_id = lastMessage.content[0]['image_file'].file_id
			newMessage=createNewMessage('', false);
			newMessage.setHasImage(true);
			var url1="https://api.openai.com/v1/files/"+image_file_id+"/content"
			getImageUrl(url1, newMessage);
			/*
			axios.get(url1,{
				  headers: {
				    Authorization: "Bearer "+API_KEY
				  }
				})
		      .then((res) => {
				console.log('res.data: '+btoa(unescape(encodeURIComponent(res.data))));
				newMessage.setImageContent(btoa(unescape(encodeURIComponent(res.data))));
				setMessages([...messages, newMessage]);
		      })
			
			var image_file=client.files.content(image_file_id);
			console.log('image file: '+JSON.stringify(image_file));
			newMessage.setImageContent(image_file.content);
			setMessages([...messages, newMessage]);
			
			var url=SERVER_URL + "/downloadImage/"+image_file_id;
			if (SERVER_URL.includes('localhost'))
				url=SERVER_URL + "/downloadImage/"+image_file_id;
			else
				url=SERVER_URL + "color/downloadImage/"+image_file_id;
			axios.get(url).then((res) => {setData(res.data)})
			*/
		}else{
      		console.log(lastMessage.content[0]["text"].value);
			newMessage=createNewMessage(lastMessage.content[0]["text"].value, false);
      		setMessages([...messages, createNewMessage(lastMessage.content[0]["text"].value, false)]);
			var annots=lastMessage.content[0]["text"].annotations;
			for (let i = 0; i < annots.length; i++) {
			  	var annot = annots[i];
				if(annot.type==='file_path'){
					newMessage.setHasImage(true);
					var url2="https://api.openai.com/v1/files/"+annot.file_path.file_id+"/content"
					getImageUrl(url2, newMessage);
					/*
					axios.get(url2,{
						  headers: {
						    Authorization: "Bearer "+API_KEY
						  }
						})
				      .then((res) => {
						console.log('res.data: '+btoa(unescape(encodeURIComponent(res.data))));
						newMessage.setImageContent(btoa(unescape(encodeURIComponent(res.data))));
						setMessages([...messages, newMessage]);
				      })					
					
					var image_file=client.files.content(annot.file_path.file_id);
					console.log('image file: '+JSON.stringify(image_file))
					newMessage.setImageContent(image_file.content);
					
					var url=SERVER_URL + "/downloadImage/"+annot.file_path.file_id;
					if (SERVER_URL.includes('localhost'))
						url=SERVER_URL + "/downloadImage/"+annot.file_path.file_id;
					else
						url=SERVER_URL + "color/downloadImage/"+annot.file_path.file_id;
				    axios.get(url).then((res) => {setData(res.data)})
					*/
				}
			}
			if(annots.length===0)
				setMessages([...messages, newMessage]);
		}
    }
  };

  // detect enter key and send message
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSendMessage();
    }
  };

  return (
	<table border='0'>
		<tbody><tr>
	<td style={{ width: "50%", scroll: "auto" }}>
	  <div style={{ position:"relative", height: "500px", width: "700px"  }}>
        <Container>
		<div style={{ width: "680px", height: "450px", overflowY: "auto"}}>
	      <Grid container direction="column" spacing={2} paddingBottom={2}>
	        {messages.map((message, index) => (
	          <Grid item alignSelf={message.isUser ? "flex-end" : "flex-start"} key={index}>
	            <Message key={index} message={message} />
	          </Grid>
	        ))}
	      </Grid>
			<div ref={bottomRef}></div>
		</div>
	      <Grid container direction="row" paddingBottom={5} justifyContent={"space-between"}>
	        <Grid item sm={11} xs={9}>
	          <TextField
	            label="Type your message"
	            variant="outlined"
	            disabled={isWaiting}
	            fullWidth
	            value={input}
	            onChange={(e) => setInput(e.target.value)}
	            onKeyDown={handleKeyPress}
	          />
	          {isWaiting && <LinearProgress color="inherit" />}
	        </Grid>
	        <Grid item sm={1} xs={3}>
	          <Button variant="contained" size="large" color="primary" onClick={handleSendMessage} disabled={isWaiting}>
	            {isWaiting && <CircularProgress color="inherit" />}
	            {!isWaiting && <SendIcon fontSize="large" />}
	          </Button>
	        </Grid>
	      </Grid>
	    </Container>
      </div>	
	</td>
	</tr></tbody>
	</table>
  );
};
export default ExcelAnalysis;